module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-30 w-800"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业简称",
      "prop": "company_name"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    attrs: {
      "placeholder": "请输入企业简称",
      "clearable": ""
    },
    model: {
      value: (_vm.form.company_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "company_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.company_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业全称",
      "prop": "rise_company_name"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    attrs: {
      "placeholder": "请输入企业全称",
      "clearable": ""
    },
    model: {
      value: (_vm.form.rise_company_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "rise_company_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.rise_company_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "纳税人识别号",
      "prop": "rise_discern_code"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    attrs: {
      "placeholder": "请输入纳税人识别号",
      "clearable": ""
    },
    model: {
      value: (_vm.form.rise_discern_code),
      callback: function($$v) {
        _vm.$set(_vm.form, "rise_discern_code", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.rise_discern_code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业注册地址",
      "prop": "rise_company_addr"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    attrs: {
      "placeholder": "请输入企业注册地址",
      "clearable": ""
    },
    model: {
      value: (_vm.form.rise_company_addr),
      callback: function($$v) {
        _vm.$set(_vm.form, "rise_company_addr", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.rise_company_addr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业联系电话",
      "prop": "rise_company_phone"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    attrs: {
      "placeholder": "请输入企业联系电话",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.set_phone()
      }
    },
    model: {
      value: (_vm.form.rise_company_phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "rise_company_phone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.rise_company_phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行名称",
      "prop": "rise_bank_name"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    attrs: {
      "placeholder": "请输入开户行名称",
      "clearable": ""
    },
    model: {
      value: (_vm.form.rise_bank_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "rise_bank_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.rise_bank_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户银行账号",
      "prop": "rise_bank_code"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    attrs: {
      "placeholder": "请输入开户银行账号",
      "clearable": ""
    },
    model: {
      value: (_vm.form.rise_bank_code),
      callback: function($$v) {
        _vm.$set(_vm.form, "rise_bank_code", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.rise_bank_code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "w-500",
    attrs: {
      "label": "纳税人性质",
      "prop": "vat_type"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.vat_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "vat_type", $$v)
      },
      expression: "form.vat_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("小规模纳税人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("一般纳税人")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业超级管理员",
      "prop": "username"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    attrs: {
      "clearable": "",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.username"
    }
  }), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "若该用户未注册，则自动注册；若该用户已注册，自动绑定到该用户下",
      "placement": "right"
    }
  }, [_c('el-button', {
    staticClass: "el-icon-warning",
    attrs: {
      "size": "small"
    }
  }, [_vm._v("  提示")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "user_name"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    attrs: {
      "placeholder": "请输入姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.form.user_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "user_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.user_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "允许使用模块"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.mokuai),
      callback: function($$v) {
        _vm.$set(_vm.form, "mokuai", $$v)
      },
      expression: "form.mokuai"
    }
  }, _vm._l((_vm.mokuai), function(item) {
    return _c('el-checkbox', {
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.menu_name))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "m-t-30"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返 回")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-182ac7ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/company/add.vue
// module id = 1809
// module chunks = 2